import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { Box, Collapse, IconButton, LinearProgress,
    Paper, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow,Tooltip,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import {useHistory} from "react-router-dom";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CreateIcon from '@material-ui/icons/Create';
import {ErrorGeneral, llamaApiCargaToken} from '../../funciones/ClienteAxios';
import NuevoEditHorometro from './NvoEditHorometro';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'; 
import ModDetalle from './ModalDetalle'
import LocationOnIcon from '@material-ui/icons/LocationOn';
import {findNumber} from "../../funciones/FindNumber";
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: window.innerHeight - 170,
        minHeight: 280,
        minWidth: '100%',
    },
    container2: {
        maxHeight: 550,
    },
    tableRow: {
        "&$selected, &$selected:hover": {
            backgroundColor: process.env.REACT_APP_COLOR
        }
    },
    tableCell: {
        "$selected &": {
            color: "white"
        }
    },
    hover: {},
    selected: {}
});

export default function TablaHorometro({   regisMaquinaria, fSeleccionadas, buscar  }) {
    const classes = useStyles();
    let history = useHistory();
    const idusu = localStorage.getItem('UsuId');
    const source = axios.CancelToken.source();
    const auxColor=process.env.REACT_APP_COLOR    
    const [registro, setRegistro] = useState([]);
    const [modalMapa, setModalMapa] = useState(false);
    const [open, setOpen] = useState(false);
    const [espera, setEspera] = useState(false);
    const [ordenSelecc, setOrdenSelecc] = useState(0);
    const [seleccionadoEdit, setSeleccionadoEdit] = useState([]);
    const [modalEdit, setModalEdit] = useState(false);
    const [datos, guardarDatos] = useState([])
    const [sinDatos, guardarSinDatos] = useState(true)    
    const [modNvo, setModNvo] = useState(false)    
    const [hrsTotal, setHrsTotal] = useState(0)    

    useEffect(() => {                  
        
        getListTabla(regisMaquinaria.Id)
        return () => {
            source.cancel();
        }
    }, [regisMaquinaria, buscar]);

      const getListTabla = (Maquinaria) => {        
        const fInicio=moment(fSeleccionadas.inicio).format("YYYY-MM-DD")
        const fFinal=moment(fSeleccionadas.final).format("YYYY-MM-DD")
        const data = qs.stringify({
            Usuario:idusu,
            Maquinaria: Maquinaria,
            FIni:`${fInicio}T00:00:00`,
            FFin:`${fFinal}T23:59:59`,
            ip:"172.2.2.2",
            idDispositivo: '89y7gttvjhj98h'
        });
        const url = "/maquinaria/horometro/fecha";

        function respuestaListTabla(aux) {
            if (aux[0].Id !== -1 && aux[0].Id !== "-1") {
                guardarDatos(aux)                    
                let valorSuma=0
                aux.forEach((horo)=>{
                    valorSuma=(horo.Fin - horo.Ini) + valorSuma
                })
              //  console.log(valorSuma);
                
                setHrsTotal(valorSuma)
            } 
        }

        llamaApiCargaToken(data, url, respuestaListTabla, ErrorGeneral, setEspera, history, source);
    };   

 
    const seleccionado = (auxReg) => {
        const auxF =moment.utc(auxReg.FCap).local(true).format("DD/MM/YYYY HH:mm")
        setRegistro({...auxReg, auxF:auxF})       
    }

    function nvoReg() {
        setModNvo(true)
    }

    function editarReg( ) {
        //setSeleccionadoEdit(auxFalla)

        setModalEdit(true)
    }

    function verMas(auxId) {

        if (auxId === ordenSelecc) {
            setOpen(!open)
        } else {
            setOpen(true)
        }
        setOrdenSelecc(auxId)
    }

    const minuscula=(cadena)=>{
        let nvo=""
        nvo = cadena.substring(0,1) + cadena.substring(1,cadena.length).toLowerCase()
        return nvo}

    function Row(props) {
        const {row} = props;
        //console.log("nuevo");
             const auxMap=  row.Ln!==0 && row.Lt!==0 ? <Tooltip title={`Ver Mapa`}>
        <IconButton   aria-label="add circle" size="small" 
            onClick={() => setModalMapa(true)} component="span">
            {registro?.Id === row.Id ? 
                <LocationOnIcon style={{color:'white',width:18+'px'}} />
                :<LocationOnIcon style={{width:18+'px'}} color="primary"/>
            }
            </IconButton>                            
        </Tooltip>  :null
        return (
        <>
            <TableRow onClick={() => { seleccionado(row); }}
                className={classes.tableRow} selected={registro?.Id === row.Id}
                classes={{hover: classes.hover, selected: classes.selected}}
            >
         
                <TableCell align="center" padding={'none'} style={{maxWidth: 30 + 'px'}}>
                    <Tooltip title={row.Encendido ===0 ? 'Apagado' : 'Encendido'}>
                        {( registro?.Id === row.Id ? 
                            <FiberManualRecordIcon style={{color: 'white'}}/> 
                            :   <FiberManualRecordIcon style={{color:row.Encendido ===0?"": '#27e365'}}/>)}
                    
                    </Tooltip>
                </TableCell> 
                 
                <TableCell align="center" padding={'none'} style={{maxWidth: 30 + 'px'}}>
                    <Tooltip title={'Editar'}>
                        <IconButton aria-label="add circle" size="small" onClick={() => editarReg( )}
                            component="span">
                            {registro?.Id === row.Id ? <CreateIcon style={{color: 'white'}}/> :
                                <CreateIcon color="primary"/>}
                        </IconButton>
                    </Tooltip>
                </TableCell>   
                <TableCell align="center" padding={'none'} style={{maxWidth: 30 + 'px'}}>
                    {auxMap}
                </TableCell> 
            {/*     <TableCell className={classes.tableCell} align="left" padding={'none'} style={{width: 75 + 'px'}}>
                    {moment.utc(row.FReg).local(true).format("DD/MM/YYYY HH:mm")}
                </TableCell> */}
                <TableCell className={classes.tableCell} align="center" padding={'none'} style={{width: 140 + 'px'}}>
                    {moment.utc(row.FCap).local(true).format("DD/MM/YYYY")}
                </TableCell>
             {/*     <TableCell className={classes.tableCell} align="left" padding={'none'} style={{width: 75 + 'px'}}>
                    {moment.utc(row.FApaga).local(true).format("DD/MM/YYYY HH:mm")}
                </TableCell> */}
              {/*   <TableCell className={classes.tableCell} align="center" style={{   width: 50 + 'px'}}
                    padding={'none'}>{row.RefId !== 0 ? row.RefNom :""}
                </TableCell> */}
                <TableCell className={classes.tableCell} align="right" style={{  width: 120 + 'px', paddingLeft:"8px"}}
                    padding={'none'}>{row.Ini}
                </TableCell>
                <TableCell className={classes.tableCell} align="right" style={{  width: 120 + 'px', paddingLeft:"8px"}}
                    padding={'none'}>{row.Fin}
                </TableCell>
                <TableCell className={classes.tableCell} align="right" style={{  width: 120 + 'px', paddingLeft:"8px" , paddingRight:"8px"}}
                    padding={'none'}>{(row.Fin-row.Ini).toFixed(2)}
                </TableCell>
            </TableRow>
            
        </>
        );
    }

    const celdaVacia = <TableCell className={classes.tableCell} align="left" padding={'none'}></TableCell>

    function tablaCompleta(auxlista) {
        
        return (
        <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell align="center" padding='none' >    </TableCell> 
                    <TableCell align="center" padding='none' >     
                   {` `}</TableCell> 
                   <TableCell align="center" padding='none' >     
                   {` `}</TableCell> 
                    <TableCell align="center" padding='none'>F. Captura</TableCell> 
                   
                    <TableCell align="center" padding='none'>Inicio </TableCell>                    
                    <TableCell align="center" padding='none'>Fin </TableCell>
                    <TableCell align="center" padding='none'>{`Horas (${(hrsTotal).toFixed(2)})`} </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow className={classes.tableRow}>
                    <TableCell className={classes.tableCell} align="center" padding={'none'}
                                style={{width: 30 + 'px'}}>
                        {findNumber('|2|') ? 
                            <Tooltip title={'Agregar Registro'}>
                                <IconButton aria-label="agregar-Registro" size="small"
                                    onClick={() => nvoReg()} component="span">
                                    <AddIcon color="primary"/>
                                </IconButton>
                            </Tooltip>
                        : null}
                    </TableCell>
                    <TableCell className={classes.tableCell} align="center" padding={'none'}
                        style={{fontWeight: 700, color: auxColor}}>
                        {findNumber('|2|') ?  'Agregar' : ""} 
                    </TableCell>
                    <TableCell className={classes.tableCell} align="center" padding={'none'} style={{
                        paddingLeft: 5 + 'px',
                        fontWeight: 700,
                        color: auxColor
                    }}>{findNumber('|2|') ?  'Registro' : ""}</TableCell>
                    {celdaVacia}
                    {celdaVacia}
                    {celdaVacia}
                    {celdaVacia}
                  
                    
                </TableRow>
                {auxlista.length !== 0 ? (auxlista.map((row) => (
                     <Row key={row.Id} row={row}/> 
                    
                ))) : null}
            </TableBody>
        </Table>
        </TableContainer>
        )
    }

    const tablaSinDatos = () => {
        return (
        <TableContainer className={classes.container2}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center" padding='none'>                            
                        </TableCell>
                        <TableCell align="left" padding='none'>Fecha</TableCell>
                      
                    </TableRow>
                </TableHead>
                <TableBody>
                     <TableRow className={classes.tableRow}>
                        <TableCell className={classes.tableCell} align="center" padding={'none'}
                            style={{width: 40 + 'px', paddingLeft: 10 + 'px'}}>
                            {findNumber('|2|') ? 
                                <IconButton aria-label="agregar-Registro" size="small" 
                                    onClick={() => nvoReg()} component="span">
                                    <AddIcon color="primary"/>
                                </IconButton>
                                : null}
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center" padding={'none'}
                                    style={{
                                        width: 120 + 'px',
                                        paddingLeft: 5 + 'px',
                                        fontWeight: 700,
                                        color: auxColor
                                    }}>
                                {findNumber('|2|') ?  'Nuevo' : ""}
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center" padding={'none'}
                                    style={{
                                        width: 30 + 'px',
                                        paddingLeft: 5 + 'px',
                                        fontWeight: 700,
                                        color: auxColor
                                    }}>
                            {findNumber('|2|') ?  'Registro' : ""}
                        </TableCell>
                        {celdaVacia}
                        {celdaVacia}
                    </TableRow>
                    <TableRow  className={classes.tableRow} >
                        
                        <TableCell className={classes.tableCell} align="left">Sin</TableCell>
                        <TableCell className={classes.tableCell} align="left">Registros</TableCell>

                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
        )
    }

    const tablaSinResultados = () => {
        return (
        <TableContainer className={classes.container2}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell align="center">  </TableCell>
                    <TableCell align="left">Fecha</TableCell>
                    <TableCell align="left">Estatus</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow className={classes.tableRow} >
                   
                    <TableCell className={classes.tableCell} align="left">Sin</TableCell>
                    <TableCell className={classes.tableCell} align="left">coincidencias</TableCell>
                </TableRow>
            </TableBody>
        </Table>
        </TableContainer>
        )
    }
    const modMapa = modalMapa ? <ModDetalle modalAbierto={modalMapa} setModalAbierto={setModalMapa} titulo={`Mapa ${registro.auxF}`}  registro={registro} /> :null 
    const modNvoEdit = modalEdit ?<NuevoEditHorometro modalAbierto={modalEdit} setModalAbierto={setModalEdit} registroH={registro}
                                titulo={"Editar Registro"} regisMaquinaria={regisMaquinaria} funcionActuliza={getListTabla} /> :null
    const modNvoHoro = modNvo ?<NuevoEditHorometro modalAbierto={modNvo} setModalAbierto={setModNvo} registroH={[]}
                                titulo={"Nuevo Registro"} regisMaquinaria={regisMaquinaria} funcionActuliza={getListTabla} /> :null
    const contenido = datos.length !== 0  ? tablaCompleta(datos) : tablaSinDatos()
    const tabla = espera ? (<Box style={{paddingTop:"5rem"}} ><LinearProgress/> </Box>) : (contenido)
 
    return (
    <Paper className={classes.root}>
        {tabla}
        {modNvoEdit}
        {modMapa}
        {modNvoHoro}
    </Paper>
    );
}